import React from 'react';

const Waiver = () => {
  return (
    <div className="pt-16 px-4 min-h-screen bg-background text-light">
      <div className="max-w-4xl mx-auto py-12">
        <h1 className="text-4xl font-bold text-primary mb-8">Release of Liability and Assumption of Risk Agreement</h1>
        
        <section className="mb-12">
          <div className="bg-light-gray p-6 rounded-lg shadow-lg">
            <p className="text-secondary mb-6 font-bold">
              BY PURCHASING A TICKET, REGISTERING FOR A CLASS, AND/OR PARTICIPATING IN OUR DANCE CLASS OR EVENT, YOU AGREE TO THE FOLLOWING TERMS AND CONDITIONS:
            </p>
            
            <div className="space-y-6 text-secondary">
              <div>
                <h2 className="text-xl font-bold text-primary mb-3">1. ACKNOWLEDGMENT AND ASSUMPTION OF RISKS</h2>
                <p className="mb-4">
                  As a participant in our dance class or event (the "Activity"), you acknowledge that participation involves inherent risks and dangers that may result in personal injury, illness, permanent disability, property damage, or death. These risks include, but are not limited to:
                </p>
                <ul className="list-disc list-inside mb-4 ml-4">
                  <li>Physical exertion or injury common in dance activities</li>
                  <li>Contact with other dancers during partner or group dance activities</li>
                  <li>Crowded environments and interaction with other attendees</li>
                  <li>Potential falls, slips, or collisions on the dance floor</li>
                  <li>Exposure to loud music and lights</li>
                  <li>Potential venue-related hazards</li>
                </ul>
                <p className="font-bold">
                  YOU FULLY UNDERSTAND THESE RISKS AND VOLUNTARILY CHOOSE TO PARTICIPATE IN THE ACTIVITY, ASSUMING ALL RISKS OF INJURY, ILLNESS, OR DEATH.
                </p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-primary mb-3">2. RELEASE OF LIABILITY</h2>
                <p>
                  By purchasing a ticket and/or participating in the Activity, you (and on behalf of your heirs, assigns, personal representatives, and next of kin) HEREBY RELEASE, INDEMNIFY, AND HOLD HARMLESS Rueda de la Vida Dance Society, its officers, directors, officials, agents, employees, volunteers, sponsors, advertisers, venue owners/operators, and other participants (collectively, the "Released Parties") FROM ANY AND ALL CLAIMS, DEMANDS, LOSSES, DAMAGES, AND LIABILITY arising out of or related to ANY INJURY, DISABILITY, OR DEATH you may suffer, or ANY DAMAGE TO PROPERTY, arising from or in connection with your participation in the Activity, WHETHER ARISING FROM THE NEGLIGENCE OF THE RELEASED PARTIES OR OTHERWISE, to the fullest extent permitted by law.
                </p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-primary mb-3">3. COVENANT NOT TO SUE</h2>
                <p>
                  You agree not to institute any suit or action at law or otherwise against the Released Parties, nor to assist in the prosecution of any claim for damages on account of any injury, death, or property damage sustained in connection with the Activity.
                </p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-primary mb-3">4. INDEMNIFICATION</h2>
                <p>
                  You agree to indemnify, defend, and hold harmless the Released Parties from any and all claims, actions, suits, procedures, costs, expenses, damages, and liabilities, including attorney's fees, arising from or in connection with your participation in the Activity.
                </p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-primary mb-3">5. HEALTH AND SAFETY</h2>
                <p>
                  You certify that you are physically fit and sufficiently prepared to participate in the Activity. You authorize the Activity organizers to obtain medical treatment for you in case of injury, accident, or illness during the Activity, and agree to be responsible for all costs associated with such medical treatment.
                </p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-primary mb-3">6. COMPLIANCE WITH RULES</h2>
                <p>
                  You agree to comply with all rules, regulations, and instructions of the Activity organizers, instructors, staff, and venue personnel during the Activity. Failure to comply may result in immediate removal without refund.
                </p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-primary mb-3">7. MEDIA RELEASE</h2>
                <p>
                  You grant permission to Rueda de la Vida Dance Society to use photographs, video recordings, or any other record of your participation in the Activity for any legitimate purpose, including publicity, advertising, and web content. If you do not wish to be photographed or recorded, please inform the organizers prior to the start of the Activity.
                </p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-primary mb-3">8. PAYMENT AND RESERVATION POLICIES</h2>
                <p>
                  Payments for classes and events are non-refundable except as required by law. The Activity organizers reserve the right to refuse entry or remove any person from the venue. Class registrations and event tickets may not be resold or transferred without prior written consent of the Activity organizers.
                </p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-primary mb-3">9. SEVERABILITY</h2>
                <p>
                  If any provision of this Agreement is held to be invalid or unenforceable, the remainder of this Agreement shall nevertheless remain in full force and effect.
                </p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-primary mb-3">10. APPLICABLE LAW</h2>
                <p>
                  This Agreement shall be governed by the laws of the Province of British Columbia, without regard to its conflict of law principles.
                </p>
              </div>

              <div className="pt-4 border-t border-secondary border-opacity-20">
                <p className="font-bold mb-4">
                  BY PURCHASING A TICKET, REGISTERING FOR A CLASS, AND/OR PARTICIPATING IN THE ACTIVITY, YOU ACKNOWLEDGE THAT YOU HAVE READ THIS AGREEMENT, FULLY UNDERSTAND ITS TERMS, UNDERSTAND THAT YOU HAVE GIVEN UP SUBSTANTIAL RIGHTS BY AGREEING TO IT, AND AGREE TO IT FREELY AND VOLUNTARILY WITHOUT ANY INDUCEMENT.
                </p>
                <p className="mb-4">
                  FOR PARTICIPANTS OF MINORITY AGE (UNDER 18), A PARENT OR LEGAL GUARDIAN MUST REVIEW THIS AGREEMENT AND TAKE RESPONSIBILITY FOR THE MINOR'S PARTICIPATION.
                </p>
                <p className="text-sm">
                  Last Updated: March 3, 2025
                </p>
                <div className="mt-4">
                  <p className="text-sm">
                    Rueda de la Vida Dance Society<br />
                    info@ruedadance.org
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Return to Classes Button */}
        {/* <div className="text-center mt-8">
          <a 
            href="/lessons" 
            className="inline-block bg-primary text-light px-6 py-3 rounded-full hover:bg-opacity-90 transition-colors"
          >
            Return to Classes
          </a>
        </div> */}
      </div>
    </div>
  );
};

export default Waiver;